<!-- @format -->

<div
    class="checkbox-container hmf-position-relative hmf-pr-xxs"
    [class]="showMore() ? 'view-less' : 'view-more'">
    @for (
        filterOption of filteredList();
        track trackFilterName(filterOption)) {

        @if (
            !(attributeName() === GTGT_FILTER_NAME && filterOption.value === 'N')
        ) {
            <plp-components-filter-option
                [class]="!allowCollapsing() && $last ? '' : 'hmf-mb-xxs'"
                [filterOption]="filterOption"
                [attributeName]="attributeName()"
                [attributeIdentifier]="attributeIdentifier()"
                [ariaLabel]="ariaLabels()[$index]"
                [displayValue]="displayValues()[$index]"
                [isMobile]="isMobile()"
                [disabled]="disabled()"
                [selectedOptions]="selectedOptions()"
                (setSelectedFilter)="setSelectedFilter($event)"
                (setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
            </plp-components-filter-option>
        }
    }
</div>
@if (allowCollapsing() && hasOverflow()) {
    <button
        hmf-action-text
        variant="secondary"
        (click)="toggleShowMore()">
        {{ showMore() ? 'View Less' : 'View More' }}
    </button>
}